import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FullSectionText from '@com/FullSectionText';
import loadable from '@loadable/component';

const Footer = loadable(() => import('@com/footer/Footer'));
const Header = loadable(() => import('@com/header/Header'));
const SearchList = loadable(() => import('@com/layouts/search/SearchList'));
const TopSection = loadable(() => import('@com/TopSection'));

function SearchResult(): JSX.Element {
  const { category } = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const keyword = searchParams.get('s');
  const { t } = useTranslation();

  const tabIndexMap: Record<string, number> = {
    collection: 0,
    item: 1,
    user: 2,
  };

  const selectedIndex = useMemo(() => {
    return tabIndexMap[String(category)] || 0;
  }, [category]);

  return (
    <>
      <Header />
      <TopSection sectionName={t('search.result', { keyword })} />
      <FullSectionText>
        <Tabs
          selectedIndex={selectedIndex}
          onSelect={(index) => {
            navigate(
              `/search/${Object.keys(tabIndexMap)[index]}${location.search}`
            );
          }}
        >
          <TabList className="center fs-21 search-tab-list">
            <Tab className="search-tab">{t('footer.collection')}</Tab>
            <Tab className="search-tab">{t('search.nft')}</Tab>
            <Tab className="search-tab">{t('general.user')}</Tab>
          </TabList>

          <div className="content-tab min-h-50">
            <TabPanel>
              <SearchList category="collection" keyword={keyword} />
            </TabPanel>

            <TabPanel>
              <SearchList category="item" keyword={keyword} />
            </TabPanel>

            <TabPanel>
              <SearchList category="user" keyword={keyword} />
            </TabPanel>
          </div>
        </Tabs>
      </FullSectionText>
      <Footer />
    </>
  );
}

export default SearchResult;
